import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import styles from "./schoolDischarge.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import formIcn from "../../../../../Assets/images/formIcn.svg";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import LoadingOverlay from "components/shared/LoadingOverlay";
import AddAttendancePop from "components/Modals/AddAttendancePop";
import { userFullName } from "helpers/common";
import moment from "moment";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import { PlusIcon } from "Assets/icons";
import { NoRecordFound } from "components/Common/Common";
import { useGetDischargeDetailsQuery } from "store/services/discharge";
import { CLIENT_NOTE_TYPES } from "config/constants";
import { SCHOOL_DISCHARGES } from "config/paths";
const SchoolDischargeDetail = () => {

  const { id: clientId } = useParams();
  const { data: clientDetails, isLoading, isFetching, refetch } = useGetDischargeDetailsQuery(clientId);
  const [getFileUrl, { isLoading: getFileLoading }] = useLazyGetFileUrlQuery();

  const [tableRow, setTableRow] = useState(null);
  const [showAddAttendanceModal, setShowAddAttendanceModal] = useState(false);

  const handleViewPdf = async (name) => {

    try {
      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };

  return (
    <>
      <AddAttendancePop
        show={showAddAttendanceModal}
        setShow={setShowAddAttendanceModal}
        clientId={clientDetails?.clientCompletedCaseload?.id}
        refetch={refetch}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid>
          {
            isLoading ? <LoadingIndicator /> : <Row>
              <Col
                lg="6"
                className=""
                style={{ borderRight: "1px solid #3da0aa4f" }}
              >
                {(getFileLoading || isFetching) && <LoadingOverlay />}
                <Row>
                  <Col lg="12" className="my-3">
                    <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                      <div className="left">
                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                          <li className="">
                            <Link
                              className="themeBlue fw-sbold"
                              style={{ textDecoration: "underline" }}
                              to={SCHOOL_DISCHARGES}
                            >
                              Client
                            </Link>
                          </li>
                          <li className="">
                            <h5 className="m-0 fw-bold themeBlue">
                              / Student Details
                            </h5>
                          </li>
                        </ul>
                      </div>

                    </div>
                  </Col>
                  <Col lg="12" className="my-3">
                    <div className="top d-flex align-items-center gap-10">
                      <div
                        className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                        style={{ height: 35, width: 35, background: "#DBDBDB" }}
                      >
                        {clientDetails?.firstname[0]?.toUpperCase() + clientDetails?.lastname[0]?.toUpperCase()}
                      </div>
                      <div className="content">
                        <h6 className="m-0 themeBlue fw-sbold text-capitalize">{userFullName(clientDetails)}</h6>
                      </div>
                    </div>
                    <Row>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            DOB
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Gender
                          </h6>
                          <p className="m-0 themeBlue pt-2 text-capitalize">{clientDetails?.client_detail?.gender || "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            School
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.client_school_detail?.client_school?.name || "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            Grade
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.grade || "--"}</p>
                        </div>
                      </Col>
                      <Col md="4" sm="6" className="my-2">
                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                          <h6 className="m-0 themeBlue fw-bold">
                            {" "}
                            <span className="" style={{ color: "#3DA0AA" }}>
                              ■
                            </span>{" "}
                            City/Town
                          </h6>
                          <p className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.city_town || "--"}</p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="12" className="my-3">
                    <NotesComponent
                      client_id={clientId}
                      module={CLIENT_NOTE_TYPES[clientDetails?.client_detail?.client_type]}
                    />
                  </Col>
                  {
                    clientDetails?.client_detail?.client_guardian_mapping?.map((item, index) => {

                      if (item?.client_guardian?.client_role?.title == "Parent") return (<Col key={index} lg="12" className="my-1">
                        <div className="py-2">
                          <h6 class="m-0 themeBlue fw-bold pb-2">
                            {" "}
                            <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                              ■
                            </span>{" "}
                            {index ? `Parent-${index} Contact Details` : "Parent Contact Details"}
                          </h6>
                          <div
                            className="cardCstm rounded p-3 shadow"
                            style={{ border: "1px solid rgb(61, 160, 170)" }}
                          >
                            <Row>
                              <Col md="4" sm="6" className="my-2">
                                <h6 class="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span
                                    class=""
                                    style={{ color: " rgb(61, 160, 170)" }}
                                  >
                                    ■
                                  </span>{" "}
                                  Last Name
                                </h6>
                                <p className="m-0 themeBlue text-capitalize">{item?.client_guardian?.lastname || "--"}</p>
                              </Col>
                              <Col md="4" sm="6" className="my-2">
                                <h6 class="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span
                                    class=""
                                    style={{ color: " rgb(61, 160, 170)" }}
                                  >
                                    ■
                                  </span>{" "}
                                  First Name
                                </h6>
                                <p className="m-0 themeBlue text-capitalize">{item?.client_guardian?.firstname || "--"}</p>
                              </Col>
                              <Col md="4" sm="6" className="my-2">
                                <h6 class="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span
                                    class=""
                                    style={{ color: " rgb(61, 160, 170)" }}
                                  >
                                    ■
                                  </span>{" "}
                                  Phone
                                </h6>
                                <p className="m-0 themeBlue">{item?.client_guardian?.phone || "--"}</p>
                              </Col>
                              <Col md="4" sm="6" className="my-2">
                                <h6 class="m-0 themeBlue fw-bold">
                                  {" "}
                                  <span
                                    class=""
                                    style={{ color: " rgb(61, 160, 170)" }}
                                  >
                                    ■
                                  </span>{" "}
                                  Email
                                </h6>
                                <p
                                  className="m-0 themeBlue"
                                  style={{ lineHeight: "20px ", wordBreak: "break-all" }}
                                >
                                  {item?.client_guardian?.email || "--"}                                </p>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>)
                    })
                  }
                  <Col lg="12" className="my-3">
                    <Row>
                      {
                        clientDetails?.clientCompletedCaseload?.clientCaseloadTherapist?.map((item, index) => {

                          return (<Col md="6" className="my-2">
                            <h6 class="m-0 themeBlue fw-bold pb-2">
                              {" "}
                              <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                ■
                              </span>{" "}
                              Discipline: {item?.caseDiscipline?.assign_term || "--"}
                            </h6>
                            <div
                              className="cardCstm rounded shadow"
                              style={{ border: "1px solid rgb(61, 160, 170)" }}
                            >
                              <div className="top px-2">
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="left">
                                    <h6
                                      class="m-0 themeBlue fw-bold pb-2"
                                      style={{ fontSize: 14 }}
                                    >
                                      {" "}
                                      <span
                                        class=""
                                        style={{ color: " rgb(61, 160, 170)" }}
                                      >
                                        ■
                                      </span>{" "}
                                      Service Status
                                    </h6>
                                    <div className="content">
                                      <p
                                        className="m-0 status border fw-sbold px-3 inline-block text-center rounded-pill yellowStatus"
                                        style={{
                                          maxWidth: "max-content",
                                          fontSize: 14,
                                        }}
                                      >
                                        {item?.caseStatus?.title || "--"}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="right my-2">
                                    <h6
                                      class="m-0 themeBlue fw-bold pb-2"
                                      style={{ fontSize: 14 }}
                                    >
                                      {" "}
                                      <span
                                        class=""
                                        style={{ color: " rgb(61, 160, 170)" }}
                                      >
                                        ■
                                      </span>{" "}
                                      Referred
                                    </h6>
                                    <div className="content">
                                      <p
                                        className="m-0 "
                                        style={{
                                          maxWidth: "max-content",
                                          fontSize: 14,
                                        }}
                                      >
                                        16/07/2024
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="left">
                                    <h6
                                      class="m-0 themeBlue fw-bold pb-2"
                                      style={{ fontSize: 14 }}
                                    >
                                      {" "}
                                      <span
                                        class=""
                                        style={{ color: " rgb(61, 160, 170)" }}
                                      >
                                        ■
                                      </span>{" "}
                                      Assessment Date
                                    </h6>
                                    <div className="content">
                                      <p
                                        className="m-0"
                                        style={{
                                          maxWidth: "max-content",
                                          fontSize: 14,
                                        }}
                                      >
                                        17/06/2024
                                      </p>
                                    </div>
                                  </div>
                                  <div className="right my-2">
                                    <h6
                                      class="m-0 themeBlue fw-bold pb-2"
                                      style={{ fontSize: 14 }}
                                    >
                                      {" "}
                                      <span
                                        class=""
                                        style={{ color: " rgb(61, 160, 170)" }}
                                      >
                                        ■
                                      </span>{" "}
                                      Start Date
                                    </h6>
                                    <div className="content">
                                      <p
                                        className="m-0 "
                                        style={{
                                          maxWidth: "max-content",
                                          fontSize: 14,
                                        }}
                                      >
                                        16/07/2024
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="bottom px-2 py-2 d-flex align-items-center gap-10"
                                style={{ borderTop: "1px solid rgb(61, 160, 170)" }}
                              >
                                <div className="imgWrp flex-shrink-0">
                                  {/* <img
                                    // src={assignment?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                    alt=""
                                    className="img-fluid rounded-circle object-fit-cover"
                                    style={{ height: 30, width: 30 }}
                                  /> */}
                                </div>
                                <div className="content">
                                  <h6 className="m-0 fw-sbold themeBlue text-capitalize">
                                    {userFullName(item?.caseTherapist)}
                                  </h6>
                                </div>


                              </div>
                            </div>
                          </Col>)
                        })
                      }
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg="6" className="">
                <Row>
                  <Col lg="12" className="my-2">
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                      <h6 className="m-0 themeBlue fw-bold">
                        Track number of sessions
                      </h6>
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                        <li className="">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                            onClick={() => setShowAddAttendanceModal(true)}
                          >
                            <PlusIcon className="mx-1" />
                            Add Session Attendance
                          </Button>
                        </li>
                        <li className="">
                          <Button className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent">
                            <span className="icn me-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="13"
                                viewBox="0 0 9 13"
                                fill="none"
                              >
                                <path
                                  d="M0.459961 0.119792V1.67977H8.25985V0.119792H0.459961ZM3.57992 3.23975V9.61615L1.55194 7.60768L0.459961 8.69967L4.3599 12.5996L8.25985 8.69967L7.16786 7.60768L5.13989 9.61615V3.23975H3.57992Z"
                                  fill="#1C1B1F"
                                />
                              </svg>
                            </span>{" "}
                            Download Attendance
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <div
                      className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                    >
                      {!clientDetails?.clientCompletedCaseload?.clientCaseloadTherapist.length ? <NoRecordFound /> : <table className={`${styles.table} table mb-0`}>
                        <thead>
                          <tr className="">
                            <th className="text-dark fw-bold border-0 bg-transparent">
                              Discipline
                            </th>
                            <th className="text-dark fw-bold border-0 bg-transparent">
                              Attended Session
                            </th>
                            <th className="text-dark fw-bold border-0 bg-transparent">
                              Total Session
                            </th>
                            <th className="text-dark fw-bold border-0 bg-transparent"></th>
                          </tr>
                        </thead>
                        {
                          clientDetails?.clientCompletedCaseload?.clientCaseloadTherapist?.map((item, index) => {

                            return <tbody>
                              <tr key={index} onClick={() => setTableRow(tableRow == index ? null : index)}>
                                <td className="">{item?.caseDiscipline?.assign_term}</td>
                                <td className="">{item?.caseloadSessions?.filter(x => x.attendance == "present")?.length}</td>
                                <td className="">{item?.caseloadSessions?.length}</td>
                                <td className="">
                                  <Button
                                    className="border-0 p-0"
                                    variant="transparent"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <path
                                        d="M10 7.26925L6.4615 10.8078L13.5385 10.8078L10 7.26925ZM9.99825 0.500001C11.3122 0.500001 12.5473 0.749333 13.7035 1.248C14.8597 1.74667 15.8653 2.42342 16.7205 3.27825C17.5757 4.13308 18.2527 5.13833 18.7517 6.294C19.2506 7.44967 19.5 8.68442 19.5 9.99825C19.5 11.3123 19.2507 12.5473 18.752 13.7035C18.2533 14.8597 17.5766 15.8653 16.7217 16.7205C15.8669 17.5757 14.8617 18.2528 13.706 18.7518C12.5503 19.2506 11.3156 19.5 10.0017 19.5C8.68775 19.5 7.45267 19.2507 6.2965 18.752C5.14033 18.2533 4.13467 17.5766 3.2795 16.7218C2.42433 15.8669 1.74725 14.8617 1.24825 13.706C0.749416 12.5503 0.499999 11.3156 0.499999 10.0018C0.499999 8.68775 0.749331 7.45267 1.248 6.2965C1.74666 5.14033 2.42341 4.13467 3.27825 3.2795C4.13308 2.42433 5.13833 1.74725 6.294 1.24825C7.44966 0.749417 8.68442 0.500001 9.99825 0.500001ZM10 2C7.76666 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
                                        fill="#071E3E"
                                      />
                                    </svg>
                                  </Button>
                                </td>
                              </tr>
                              {
                                tableRow == index ? (
                                  <tr>
                                    <td colSpan={4} className="p-0 border-0">
                                      <div
                                        className={`${styles.tableResponsive} tableResponsive table-responsive mb-0 pb-0`}
                                      >
                                        <table className={`${styles.table} table mb-0`}>
                                          <thead>
                                            <tr className="">
                                              <th className="text-dark fw-bold bg-transparent">
                                                Date
                                              </th>
                                              <th className="text-dark fw-bold bg-transparent">
                                                Present
                                              </th>
                                              <th className="text-dark fw-bold bg-transparent">
                                                Absent
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {
                                              item?.caseloadSessions?.map((itm, idx) => {
                                                return <tr>
                                                  <td className="border-0 p-2">
                                                    {itm?.session_date ? moment(itm?.session_date).format("DD/MM/YYYY") : "--"}
                                                  </td>
                                                  <td className="border-0 p-2">
                                                    {

                                                      itm?.attendance == "present" ? <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                                                          fill="#16BF12"
                                                        />
                                                      </svg> : "-"
                                                    }
                                                  </td>
                                                  <td className="border-0 p-2">
                                                    {

                                                      itm?.attendance == "absent" ? <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                                                          fill="#16BF12"
                                                        />
                                                      </svg> : "-"
                                                    }
                                                  </td>                                                </tr>
                                              })
                                            }

                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                ) : null
                              }
                            </tbody>
                          })
                        }
                      </table>}
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <div className="d-flex justify-content-between">
                      <h5 className="m-0 themeBlue fw-bold pb-2">Attachments:</h5>

                      {/* <Button
                        style={{
                          minWidth: "unset",
                          fontSize: "12px",
                          height: "30px"
                        }}
                        className="d-flex align-items-center justify-content-center commonBtn"
                      >
                        Add Attachments
                      </Button> */}
                    </div>
                    <div
                      className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                    >
                      <table className={`${styles.table} table mb-0`}>
                        <tbody>
                          {
                            !clientDetails?.clientResources.length ? <NoRecordFound /> : clientDetails?.clientResources.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td className="">
                                    <div className="d-flex align-items-center gap-10">
                                      <span className="icn flex-shrink-0">
                                        <img
                                          src={formIcn}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <p className="m-0" role="button" onClick={() => handleViewPdf(item?.attachment_key)}>{item?.attachment_name || "--"}</p>
                                    </div>
                                  </td>
                                  <td className=""></td>
                                  <td className=""></td>
                                  <td className="">
                                    <div className="d-flex align-items-center gap-10">
                                      <Button
                                        style={{ minWidth: "unset " }}
                                        className="d-flex align-items-center justify-content-center commonBtn h-auto"
                                        onClick={() => handleViewPdf(item?.attachment_key)}
                                      >
                                        <span className="icn me-1">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="11"
                                            viewBox="0 0 16 11"
                                            fill="none"
                                          >
                                            <path
                                              d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </span>
                                        View
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          }
        </Container>
      </section>
    </>
  );
};

export default SchoolDischargeDetail;
